module.exports = __webpack_public_path__ + "static/homepage-7331966377f862482ea9644037b37caf.gif";